import React, { createContext, useContext, useState, useCallback } from 'react';
import { Lock } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { useAuth } from '../lib/AuthContext';

const UpgradeContext = createContext(null);

// Global upgrade modal: "This is a {Pro|Elite} feature. Contact us to upgrade…"
export function UpgradeProvider({ children }) {
  const [requiredPlan, setRequiredPlan] = useState(null);
  const openUpgrade = useCallback((plan = 'Pro') => setRequiredPlan(plan), []);
  const { config } = useAuth();

  return (
    <UpgradeContext.Provider value={{ openUpgrade }}>
      {children}
      <Dialog open={!!requiredPlan} onOpenChange={(o) => !o && setRequiredPlan(null)}>
        <DialogContent data-testid="upgrade-modal" className="max-w-sm rounded-2xl">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Lock className="h-5 w-5 text-amber-600" /> {requiredPlan} feature
            </DialogTitle>
            <DialogDescription className="pt-2 text-sm leading-relaxed">
              This is a {requiredPlan} feature. Contact us to upgrade:{' '}
              <span className="font-medium text-[hsl(var(--foreground))]">
                {config?.platform_mobile} / {config?.platform_email}
              </span>
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button data-testid="upgrade-modal-close-button" className="w-full h-11 rounded-xl" onClick={() => setRequiredPlan(null)}>
              Got it
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </UpgradeContext.Provider>
  );
}

export function useUpgrade() {
  return useContext(UpgradeContext);
}

// Helper: handle API errors — opens upgrade modal for plan_upgrade_required
export function planLabel(p) {
  return { starter: 'Starter', pro: 'Pro', elite: 'Elite' }[p] || 'Pro';
}
